import { render } from "./InteractiveSectionIntroBasicContent.vue?vue&type=template&id=1840c55c&scoped=true"
import script from "./InteractiveSectionIntroBasicContent.vue?vue&type=script&lang=js"
export * from "./InteractiveSectionIntroBasicContent.vue?vue&type=script&lang=js"

import "./InteractiveSectionIntroBasicContent.vue?vue&type=style&index=0&id=1840c55c&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1840c55c"]])

export default __exports__